// @ts-nocheck
/* eslint-disable */
export const closeFillIcon = {
  data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.99972 7.05767L11.2996 3.75781L12.2424 4.70062L8.94252 8.00047L12.2424 11.3003L11.2996 12.2431L7.99972 8.94327L4.69989 12.2431L3.75708 11.3003L7.05692 8.00047L3.75708 4.70062L4.69989 3.75781L7.99972 7.05767Z" fill="currentColor"/></svg>`,
  name: 'close-fill' as const,
};
